import { IFilterItem } from "../../model/IExportExcelRequest";
import { Person } from "../../model/Person";

export type VeteranView = "veterans" | "jubilees" | "noneveterans";

export const JubileeYears = [9, 10, 19, 20, 29, 30, 39, 40, 49, 50, 59, 60] as const;
export type JubileeYear = typeof JubileeYears[number];

export const sortVeteranId = (x: Person, y: Person) => {
    return +x.veteranId - +y.veteranId
};

export const sortName = (x: Person, y: Person) => {
    if (x.lastName == y.lastName)
        return x.firstName < y.firstName ? -1 : 1;
    return x.lastName < y.lastName ? -1 : 1;
};

export const a11yProps = (index: any) => {
    return {
        id: `simple-tab-${index}`,
        key: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
};

const tabToView = (tab: number): VeteranView => {
    switch (tab) {
        case 0:
            return "veterans";
        case 1:
            return "jubilees";
        case 2:
            return "noneveterans";
        default:
            throw new Error("Faulty tab provided")
    }
};

const tabToTitle = (tab: number, jubileeYear: JubileeYear): string => {
    switch (tab) {
        case 0:
            return "Veteraner";
        case 1:
            return `Jubilarer - ${jubileeYear}`;
        case 2:
            return "Ej veteraner?";
        default:
            throw new Error("Faulty tab provided")
    }
};

export const getExportFilter = (tab: number, jubileeYear: JubileeYear,onlyEntered : boolean): IFilterItem[] => {
    return [
        { propertyName: "view", propertyValue: tabToView(tab) },
        { propertyName: "jubileeYear", propertyValue: jubileeYear },
        { propertyName: "onlyEntered", propertyValue: onlyEntered },
        { propertyName: "title", propertyValue: tabToTitle(tab, jubileeYear) }
    ];
};
